import React from 'react';
import BaseAnimation from 'client/components/base-animation';

export default class Loader extends BaseAnimation {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div style={this.props.style} className={this.css()}>
        <div className="positionX">
          <div className="positionY">
            <div className="spinner" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/common/loader/loader.es6